import React from 'react';
import img1 from '../../assets/logos/img1.png';

import './Modal.css';

const Modal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <div className="profile-modal1-left">
            <img src={img1} alt="img1" className="profile-modal1-img" />
          </div>
          <div className="profile-right">
            <div class="cv-section">
              <h2>Formación de Empresas</h2>
              <h3>Soluciones personalizadas para emprender en los EAU</h3>
              <ul>
                <li>Evaluación detallada de tu modelo de negocio y planes de crecimiento.</li>
                <li>Selección de la jurisdicción ideal: zona franca o continental.</li>
                <li>Acceso a 100% de propiedad extranjera y beneficios fiscales.</li>
                <li>Coordinación directa con las autoridades locales.</li>
                <li>Gestión completa de la documentación y el cumplimiento normativo.</li>
              </ul>
            </div>

            <div class="cv-section">
              <h2>Residencia en los EAU</h2>
              <h3>Gestión integral de visas de residencia</h3>
              <ul>
                <li>Asesoramiento para visas de inversionista, empleado o Golden Visa.</li>
                <li>Manejo simplificado de trámites y documentación.</li>
                <li>Orientación personalizada según tus necesidades.</li>
                <li>Soporte continuo en renovaciones y cumplimiento legal.</li>
              </ul>
            </div>

            <div class="cv-section">
              <h2>Apertura de Cuentas Corporativas</h2>
              <h3>Asistencia para configurar cuentas bancarias empresariales</h3>
              <ul>
                <li>Guía en cada etapa del proceso de apertura de cuentas.</li>
                <li>Cumplimiento de estrictos requisitos regulatorios.</li>
                <li>Colaboración con bancos confiables para agilizar el trámite.</li>
                <li>Negociación de términos favorables para tu negocio.</li>
              </ul>
            </div>

            <div class="cv-section">
              <h2>Investigación de Mercados</h2>
              <h3>Identifica oportunidades estratégicas en los EAU</h3>
              <ul>
                <li>Análisis profundo del mercado y su dinámica.</li>
                <li>Identificación de oportunidades, desafíos y competidores clave.</li>
                <li>Estudios de tendencias y comportamiento del consumidor.</li>
                <li>Recomendaciones personalizadas para decisiones estratégicas.</li>
              </ul>
            </div>

            <div class="cv-section">
              <h2>Representación Comercial</h2>
              <h3>Conecta con compradores y distribuidores en los EAU</h3>
              <ul>
                <li>Vinculación con socios clave para expandir tus productos.</li>
                <li>Asistencia completa en logística de importación y cumplimiento normativo.</li>
                <li>Estrategias personalizadas para establecer una presencia sólida.</li>
              </ul>
            </div>

            <div class="cv-section">
              <h2>Cobranza de Deudas</h2>
              <h3>Recuperación eficiente de pagos pendientes</h3>
              <ul>
                <li>Recuperación profesional para proteger tu flujo de efectivo.</li>
                <li>Manejo estratégico para mantener buenas relaciones con clientes.</li>
                <li>Soluciones adaptadas a las necesidades de tu negocio.</li>
              </ul>
            </div>

            <div class="cv-section">
              <h2>Consultoría Fiscal</h2>
              <h3>Optimización y cumplimiento fiscal en los EAU</h3>
              <ul>
                <li>Estrategias para maximizar beneficios fiscales.</li>
                <li>Cumplimiento con normativas locales e internacionales.</li>
                <li>Planes personalizados para tu industria y modelo de negocio.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;